export default __webpack_public_path__ + "static/g405-0e06fc74fd1707c750e6514b9ed9c690.jpg";